import { render, staticRenderFns } from "./NoticeCallout.vue?vue&type=template&id=47bc33bd&scoped=true&"
import script from "./NoticeCallout.vue?vue&type=script&lang=js&"
export * from "./NoticeCallout.vue?vue&type=script&lang=js&"
import style0 from "./NoticeCallout.vue?vue&type=style&index=0&id=47bc33bd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bc33bd",
  null
  
)

export default component.exports